(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('CustomerOrderSearch', CustomerOrderSearch);

    CustomerOrderSearch.$inject = ['$resource'];

    function CustomerOrderSearch($resource) {
        var resourceUrl =  'api/_search/customer-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
